import FormResponse from '../../shared/classes/form-response.js';
import Uploader from './uploader.js';
import ElementConstants from '../../shared/constants/elements';
import PaymentForm from './payment-form';

import {appendCacheBuster} from '../../shared/utilities';
import captureMessage from '../utils/captureMessage.js';
import Signature from './signature'

export default class EdlioForm {
	constructor (data, responseId) {
	    var self = this;

		this.data = data;
		this.id = data.id;
		this.settings = data.settings;

		this.container = document.getElementById('form');
		this.self = document.forms[data.id];
		this.inputs = this.self ? Array.prototype.slice.call(this.self.querySelectorAll('input, textarea')) : document.querySelectorAll('input, textarea');
		this.orderSummary = document.querySelector('footer .payment-info');
		this.paymentForm = document.getElementById('payment_form_container');
		this.collectPayment = data.collectPayment;
		this.collectSignature = data.collectSignature;
		this.usePay = data.usesPay || false;
		this.transferFee = data.settings.transferFee;
		this.card = null;
		this.edlioOrderSummary = null;
		this.stripeActive = window.edlio.stripeActive;
		this.edlioPayActive = window.edlio.edlioPayActive;
		this.glAccount = data.settings.glAccount;
		this.isRecaptchaEnabled = true;

		if(data.settings.stripeAccount) {
			this.stripeAccountAssociated = data.settings.stripeAccount.id;
		} else {
			this.stripeAccountAssociated = null
		}

		const scheduledTimes = this.settings.schedule;
		if (scheduledTimes) {
			const now = Date.now();
			const opened = scheduledTimes.open && scheduledTimes.open < now;
			const closed = scheduledTimes.close && now > scheduledTimes.close;

			if (!opened && opened != undefined) {
				document.querySelector('.pre-open.message').classList.add('show');
			} else if (closed) {
				document.querySelector('.closed.message').classList.add('show');
			}
		}

		// build payment-element-id ordered list
		this.orderedPaymentElementIds = [];
		let orderedPaymentElements = document.querySelectorAll('.payment-element-id');
		// convert from NodeList to Array for IE11
		orderedPaymentElements = Array.prototype.slice.call(orderedPaymentElements);
		orderedPaymentElements.forEach(el => {
			this.orderedPaymentElementIds.push(el.id);
		});

		this.uploaders = [];
		this.attachments = {};

		this.submitButton = document.getElementById('submit_button');
		this.loader = document.getElementById('submitting_form');

		if (typeof Stripe != 'undefined' && Stripe != null && window.edlio.stripeKey && this.paymentForm) {
			this.stripe = Stripe(window.edlio.stripeKey);
		}

		if (this.settings.sendConfirmationEmail || this.settings.showConfirmationEmailInput) {
			this.confirmationEmailField = document.querySelector('#confirmation_email_field');
		}

		this.captcha = document.querySelector('.captcha');
		this.recaptchaContainer = document.getElementById('recaptcha-container');

		this.responseId = responseId;

		this.inputTypes = {
			standard: Object.keys(ElementConstants.INPUTS).map(key => {
				return ElementConstants.INPUTS[key];
			}),

			groups: Object.keys(ElementConstants.INPUT_GROUPS).map(key => {
				return ElementConstants.INPUT_GROUPS[key];
			}),

			extras: Object.keys(ElementConstants.EXTRAS).map(key => {
				return ElementConstants.EXTRAS[key];
			})
		};

		if (this.paymentForm) {
			if (this.stripeActive && this.stripeAccountAssociated) {
				var elements = this.stripe.elements();
				// Create an instance of the card Element.
				this.card = elements.create('card', {style: style});

				// Add an instance of the card Element into the `card-element` <div>.
				this.card.mount('#card-element');

				this.card.addEventListener('change', function(event) {
					var displayError = document.getElementById('card-errors');
					if (event.error) {
						displayError.textContent = event.error.message;
					} else {
						displayError.textContent = '';
					}
				});
			}

			this.paymentFormObj = new PaymentForm(this);

			this.data.fieldsets[0].rows.forEach((row) => {
				const element = row.elements[0];
				if ((element.type === "PAYMENT_ITEM" || element.type === "OPEN_PAYMENT_INPUT") && element.required) {
					let cost = element.cost;

					// We only want to push Open Payment items that
					// are required and have the same Min and Max
					// as that means the value cannot be changed
					if (element.type === "OPEN_PAYMENT_INPUT") {
						if (element.min != element.max) {
							return
						} else if (element.min === element.max) {
							cost = element.min
						}
					}

					if (document.getElementById(element.uniqueId + "_quantity")) {
						document.getElementById(element.uniqueId + "_quantity").value = element.minQuantity ? element.minQuantity > 1 ? element.minQuantity : 1 : 1;
					}

					const hasOptions = element.options && element.options.length;

					const item = {
						id: element.uniqueId,
						type: "item",
						title: hasOptions ? element.options[0].value : element.label,
						parentTitle: hasOptions ? element.label : "",
						cost,
						quantity: element.minQuantity > 1 ? element.minQuantity : 1
					};
					self.paymentFormObj.updateCartItem(item);
					self.enableSubmit();
				}
			});

			var style = {
				base: {
					fontSize: '16px',
					color: "#32325d",
				}
			};

			this.paymentFormObj.addPaymentBlockListeners();
		}

		// iframe styling
		if ( window.location !== window.parent.location ) {
			document.querySelector('html').classList.add('embedded-form');
		}
	}

	disableEditMode () {
		this.container.classList.remove('editing');
	}

	disableSubmit = () => {
		if (this.submitButton) {
			this.submitButton.classList.add('hidden');
		}

		if (this.loader && !this.collectPayment) {
			this.loader.classList.remove('hidden-init');
		}
	}

	enableEditMode () {
		this.container.classList.add('editing');
	}

	enableSubmit =  () => {
		if (this.submitButton && !this.usePay) {
			this.submitButton.classList.remove('hidden');
			this.submitButton.classList.add("show");

			if (this.loader && !this.collectPayment) {
				this.loader.classList.add('hidden-init');
			}
		}

		if (this.usePay) {
			const payContainer = document.getElementById("pay_card_info");
			const noPaymentReq = this.paymentFormObj.payTotal == 0 || false;

			if (noPaymentReq) {
				this.submitButton.classList.remove('hidden');
				this.submitButton.classList.add("show");
			} else {
				this.submitButton.classList.remove("show");
			}

			if (payContainer && this.payToken) {
				document.getElementById("processing_pay").style.display = "none";
				payContainer.style.display = "flex";
				this.submitButton.classList.remove('hidden');
				this.submitButton.classList.add("show");
			}
		}

	}

	initialize (userAgent) {
		this.self.addEventListener('submit', (evt) => evt.preventDefault());

		this._initUploaders();

		this._initSubmitButton();

		this._disableLoading();

		this.initRecaptcha();

		this.initUserSignature();
	}

	initRecaptcha() {
		let self = this;
		window.recaptchaObserver.addSubscriber(function (){
			self.disableSubmit();
			self._handleSubmit();
		});
	}

	initUserSignature() {
		if (!this.collectSignature) {
			return;
		}

		this.signatureValue = {};
		this.signature = new Signature();

		this.container.addEventListener('signatureSave', function () {
			this.signatureValue = this.signature.getSignatureValue();
		}.bind(this));
	}

	enableRecaptcha(){
		this.recaptchaContainer.classList.remove('hide');
		this.isRecaptchaEnabled = true;
	}
	
	disableRecaptcha(){
		this.recaptchaContainer.classList.add('hide');
		this.isRecaptchaEnabled = false;
	}

	populate (data) {
		if (!data) {
			return;
		}

		this._initUploaders();

		if (this.settings.showConfirmationEmailInput && data.hasOwnProperty('confirmationEmailAddress')) {
			this.confirmationEmailField.value = data.confirmationEmailAddress;
		}

		data.fields.forEach(field => {
			if (field.hasOwnProperty('uniqueId')) {
				if (field.hasOwnProperty('type') && field.type === ElementConstants.INPUTS.FILE_UPLOAD) {
					this._getUploader(field.uniqueId).renderFileList(field.values);
					this.attachments[field.uniqueId] = field.values;

				} else if (field.hasOwnProperty('type') && this.inputTypes.groups.indexOf(field.type) >= 0) {
					if (field.type === 'SELECT_MENU_GROUP') {
						let selectMenu = document.getElementById(`${field.uniqueId}_input`);

						selectMenu.querySelector(`option[value="${field.value}"]`).setAttribute('selected', 'selected');
						return;
					}

					if (field.type === 'PAYMENT_ITEM') {
						let selectMenu = document.getElementById(`${field.uniqueId}_select`);

						selectMenu.querySelector(`option[value="${field.value}"]`).setAttribute('selected', 'selected');
						return;
					}

				} else if (field.type === 'TEXT_BOX_EXTRA') {
                    // text boxes wont have user data so return early
                    return;
                } else if (field.type === ElementConstants.INPUTS.PHONE ) {
                    this._getInput(`${field.uniqueId}_input_input`).value = field.value;
                    return;
                } else {
					this._getInput(`${field.uniqueId}_input`).value = field.value;
					return;
				}
			}

			if (field.hasOwnProperty('group')) {
				if ( field.group.type === ElementConstants.INPUT_GROUPS.TABLE ) {
					field.selections.forEach(selection => {
						this._getInput(`${field.group.uniqueId}_${selection.uniqueId}`).setAttribute('checked', 'checked');
					});

					return;
				}

				field.selections.forEach(selection => {
					this._getInput(selection.uniqueId).setAttribute('checked', 'checked');

					if ( selection.custom ) {
						this._getInput(`${selection.uniqueId}_other`).value = selection.value;
					}
				});

				return;
			}
		});
	}

	// Private Methods -----------------------------------------------------------

	_disableLoading () {
		this.container.classList.remove('loading');
	}

	_enableLoading () {
		this.container.classList.add('loading');
	}

	_generateResponse () {
		let response = new FormResponse(this.data, this.responseId, this.isRecaptchaEnabled);

		this.data.fieldsets.forEach(fieldset => {
            fieldset.rows.forEach(row => {
				row.elements.forEach(element => {

					let node = document.getElementById(element.uniqueId);
					let input = document.getElementById(`${element.uniqueId}_input`);

					// Email Inputs
					if (element.type === ElementConstants.INPUTS.EMAIL) {
						let { value } = input;

						if (element.required && !value) {
							response.addField(element, value);
							response.needsRevision = true;
							this._markForRevision(node);
							return;
						}

						let invalidEmail = input.parentElement.classList.contains('error');

						if (value && invalidEmail) {
							response.addField(element, value);
							response.needsRevision = true;
							return;
						}

						this._unmark(node);
						response.addField(element, value);
						return;
					}

					// Phone Number
					if (element.type === ElementConstants.INPUTS.PHONE) {
						let phoneComponent = document.querySelector(`uniform-phone-number#${element.uniqueId}_input`);
						let value = phoneComponent.getAttribute('value');
						let invalidPhone = phoneComponent.parentElement.classList.contains('error');

						if (element.required && !value) {
							response.addField(element, value);
							response.needsRevision = true;
							this._markForRevision(node);
							return;
						}

						if (value && invalidPhone) {
							response.addField(element, value);
							response.needsRevision = true;
							return;
						}

						this._unmark(node);
						response.addField(element, value);
						return;
					}

					// File Uploads
					if (element.type === ElementConstants.INPUTS.FILE_UPLOAD) {
						if (element.required && (!this.attachments[element.uniqueId] || !this.attachments[element.uniqueId].length)) {
							response.addAttachmentGroup(element, this.attachments[element.uniqueId]);
							response.needsRevision = true;
							this._markForRevision(node);
							return;
						}

						response.addAttachmentGroup(element, this.attachments[element.uniqueId]);
						this._unmark(node);
						return;
					}

					// User signature
					if (element.type === ElementConstants.INPUTS.USER_SIGNATURE) {
						if (element.required && (!this.signatureValue || Object.keys(this.signatureValue).length === 0)) {
							response.addField(element, this.signatureValue)
							response.needsRevision = true;
							this._markForRevision(node);
							return;
						}

						response.addField(element, this.signatureValue);
						this._unmark(node);
						return;
					}

					// Standard Inputs
					if (this.inputTypes.standard.indexOf(element.type) >= 0 || element.type === ElementConstants.PAYMENTS.OPEN) {
						let { value } = input;

						if (element.required && !value) {
							response.addField(element, value);
							response.needsRevision = true;
							this._markForRevision(node);
							return;
						}

						this._unmark(node);
						response.addField(element, value);
						return;
					}

					// Select Menus
					if (element.type === ElementConstants.INPUT_GROUPS.SELECT_MENU) {

					    if (!input || !input.options) {
					        return;
                        }

						let selectedOption = input.options[input.selectedIndex].value;
						response.addField(element, selectedOption);

						if (element.required && selectedOption === '') {
							response.needsRevision = true;
							this._markForRevision(node);
							return;
						}

						this._unmark(node);
						return;
					}

					// Items
					if (element.type === ElementConstants.PAYMENTS.ITEM) {

						const variationEl = document.getElementById(`${element.uniqueId}_select`);
						const quantityEl = document.getElementById(`${element.uniqueId}_quantity`);
						const checkboxEl = document.getElementById(`${element.uniqueId}_checkbox`);

						let quantity;
						if (quantityEl) {
							quantity = quantityEl.value;
						} else if (checkboxEl) {
							quantity = checkboxEl.checked ? "1" : "";
						} else {
							// an out of stock item has neither a input nor checkbox
							quantity = "";
						}

						let selectedOption = quantity != "" ? "x" + " " + quantity : "";
                        if (variationEl && selectedOption) {
							selectedOption = variationEl.options[variationEl.selectedIndex].value + " " + selectedOption;
						}

						response.addField(element, selectedOption, quantity);

						if (element.required && selectedOption === '') {
							response.needsRevision = true;
							this._markForRevision(node);
							return;
						}

						this._unmark(node);
						return;
					}

					// Extras
					if (element.type === ElementConstants.EXTRAS.TEXT_BOX) {
						// we don't want the first text element 
						if (element.uniqueId !== 'initial_text_box') {
							response.addText(element)
						}
					}
					
					if (this.inputTypes.extras.indexOf(element.type) >= 0) {
						return;
					}
					
					// Other Input Groups
					let selections = [];
					let selected = false;

					// Tables
					if (element.type === ElementConstants.INPUT_GROUPS.TABLE) {
						element.rows.forEach(row => {
							selected = false;
							element.columns.forEach(column => {
								if (this._getInput(`${row.uniqueId}_${column.uniqueId}`).checked) {
									selections.push(column);
									selected = true;
								}
							});

							let group = {
								required: element.required,
								label: row.label,
								type: element.type,
								uniqueId: row.uniqueId,
								tableLabel: element.label
							};

							this._validateSelections(response, node, group, selections, selected);
							selections = [];
						});

						return;
					}

					// All other Input Groups
					if (element.choices) {
						element.choices.forEach(choice => {
							if ( document.getElementById(choice.uniqueId).checked ) {
								if (element.type === ElementConstants.PAYMENTS.MULTI_CHOICE) {
									selections.push({
										uniqueId: choice.uniqueId,
										cost: choice.cost,
										title: choice.label
									});
								} else {
									selections.push(choice);
								}
								selected = true;
							}
						});
					}

					if (element.customChoices) {
						element.customChoices.forEach(choice => {
							if (this._getInput(choice.uniqueId).checked) {
								if (element.type === ElementConstants.PAYMENTS.MULTI_CHOICE) {
									selections.push({
										uniqueId: choice.uniqueId,
										cost: this._getInput(`${choice.uniqueId}_other`).value,
										title: this._getInput(`${choice.uniqueId}`).getAttribute("label"),
										custom: true
									});
								} else {
									selections.push({
										uniqueId: choice.uniqueId,
										label: this._getInput(`${choice.uniqueId}_other`).value,
										custom: true
									});
								}
								selected = true;
							}
						});
					}

					this._validateSelections(response, node, element, selections, selected);
				});
			});
		});

		if (this.settings.sendConfirmationEmail || this.settings.showConfirmationEmailInput) {
			let confirmationNode = this.confirmationEmailField.parentElement;
			let confirmationEmailValue = this.confirmationEmailField.value;
			let needsConfirmationEmail = this.settings.requireConfirmationEmail && !confirmationEmailValue;
			let invalidEmail = document.getElementById('confirmation-email').classList.contains('error');

			response.needsRevision = response.needsRevision || needsConfirmationEmail;

			if (needsConfirmationEmail) {
				this._markForRevision(confirmationNode.parentElement)
			} else if (confirmationEmailValue && invalidEmail) {
				response.needsRevision = true;
				this.settings.invalidEmail = true;
				this._markForRevision(confirmationNode.parentElement);
			} else {
				if (confirmationEmailValue) {
					response.addData('confirmationEmailAddress', confirmationEmailValue);
				}

				this._unmark(confirmationNode.parentElement)
			}
		}

		return response;
	}

	_getInput (id) {
		return this.inputs.find(input => input.id === id);
	}

	_getUploader (id) {
		return this.uploaders.find(uploader => uploader.id === id);
	}

	_handleSubmit () {
		var self = this;

		let response = this._generateResponse();
		response.data.collectPayment = self.collectPayment;
		response.data.collectSignature = self.collectSignature;
		response.data.usePay = this.usePay;

		this.container.classList.remove('revising');
		if (response.needsRevision) {
			this.enableSubmit();
			this.container.classList.add('revising');
			window.scrollTo(0,0);
			return;
		}

		if (this.isRecaptchaEnabled && window.edlio.isFormsCaptchaActive && (!this.collectPayment || (this.collectPayment && window.edlio.isPayFormsCaptchaActive))) {
			let captchaResponseKey;
			if (window.grecaptcha) {
				captchaResponseKey = window.grecaptcha.getResponse();
			}			

			if (captchaResponseKey && !captchaResponseKey.length) {
				this._markForRevision(this.captcha);
				this.enableSubmit();
				return;
			}

			response.captchaResponseKey = captchaResponseKey;
		}

		if (this.paymentFormObj && this.paymentFormObj.itemCart.length) {
			// update this.edlioOrderSummary to pass to confirmation page
			this.edlioOrderSummary = this.orderSummary.outerHTML;
		}

		if (this.collectPayment && this.paymentFormObj.payTotal) {
			
			if (!this.usePay) {
				response.data.stripeAccountId = this.data.settings.stripeAccount.id || "";
			} else {
				document.getElementById("processing_pay").style.display = "flex";
			}

			this.container.classList.remove('revise-pay');

			const totalErrorEl = document.querySelector("#total_error");
			if (!this.paymentFormObj.checkPayMin("Stripe", this.paymentFormObj.payTotal)) {
				this.enableSubmit();
				totalErrorEl.classList.add('error-flex');
				return;
			} else {
				totalErrorEl.classList.remove('error-flex');
			}

			this.paymentFormObj.submitPaymentForm()
				.then((res) => {
					if (res == false) {
						captureMessage("Unable to retrieve token");
						self.enableSubmit();
						return;
					} else {
						if (!this.usePay) {
							self.stripeToken = res;
							response.data.stripeToken = res;
							response.data.stripeAccountEmail = self.settings.stripeAccount.email;
						} else {
							response.data.paymentToken = res.payToken;
							response.data.payDescriptor = res.payDescriptor;
							response.data.cardDetails = res.cardDetails;
							response.data.payFee = res.payFee;
							response.data.glAccount = self.glAccount;
						}

						response.data.paymentAmount = self.paymentFormObj.payTotal.toFixed(2);
						response.data.subTotalAmount = self.paymentFormObj.subTotal.toFixed(2);
						response.data.selectedItems = self.paymentFormObj.itemCart;
						response.data.transferFee = self.transferFee;
						if (self.confirmationEmailField) {
							response.data.receiptEmail = self.confirmationEmailField.value;
						}
						self._submit(response);
					}
				})
		} else {
			if (this.paymentFormObj && this.paymentFormObj.itemCart.length > 0) {
				response.data.selectedItems = this.paymentFormObj.itemCart;
				response.data.subTotalAmount = "0.00";
				response.data.paymentAmount = "0.00";
			}

			if (this.confirmationEmailField) {
				response.data.receiptEmail = this.confirmationEmailField.value;
			}

			this._submit(response);
		}
	}

	_initSubmitButton () {
		if (this.submitButton) {
			this.submitButton.addEventListener('click', (evt) => {
				if (this.submitButton.classList.contains('disabled')) {
					return;
				}
				evt.preventDefault();
				if(this.isRecaptchaEnabled && window.edlio.isFormsCaptchaActive && (!this.collectPayment || (this.collectPayment && window.edlio.isPayFormsCaptchaActive)) && !window.grecaptcha.getResponse()) {
					grecaptcha.execute();

					if (!window.recaptchaCloseListener) {
						initRecaptchaListener();
					}

				} else {
					this.disableSubmit();
					this._handleSubmit();
				}
				
			})
		}
	}

	_initUploaders () {
		let buckets = document.querySelectorAll('.file-upload.input .bucket');

		for (let i = 0; i < buckets.length; i++) {
			this.uploaders.push(new Uploader(this, buckets[i]));
		}
	}

	_markForRevision (node) {
		node.classList.add('revise');
	}

	_unmark (node) {
		node.classList.remove('revise');
	}

	_submit (userResponse) {
		const request = new XMLHttpRequest();
		const url = this.responseId ? `/apps/api/form/${this.id}/${this.responseId}` : `/apps/api/form/${this.id}`;

		request.open("POST", appendCacheBuster(url), true);
		request.setRequestHeader('Cache-Control', 'no-cache');
		request.onload = () => {
			if (request.status >= 200 && request.status < 400) {
				var resp = JSON.parse(request.responseText);
				userResponse.data.responseId = resp.entryId;
				sessionStorage.setItem('edlioFormResponse', userResponse.asString);
				sessionStorage.setItem('edlioOrderSummary', this.edlioOrderSummary);

				if (this.settings.confirmationDestination === 'custom_link' && this.settings.confirmationLink && this.settings.confirmationLink.trim() !== '') {
					if ( window.location !== window.parent.location ) {
						window.parent.location = this.settings.confirmationLink;
					} else {
						window.location = this.settings.confirmationLink;
						return;
					}
				}

				if(resp.closedForm){
					window.location = appendCacheBuster(`/apps/form/${this.id}`);
				} else {
					window.location = appendCacheBuster(`/apps/form/${this.id}/confirm`);
				}

			} else if (request.status === 401) {
				const errorResponse = this._parseErrorResponse(request.response);

				if (errorResponse && errorResponse.error && errorResponse.error.length > 0) {
					alert(errorResponse.status + " - " + errorResponse.error)
				} else {
					alert('An error occurred processing your request. Please refresh the page and try again.');
				}

				this._resetCaptcha();
				this.enableSubmit();
			} else {
				const errorResponse = this._parseErrorResponse(request.response);

				if (errorResponse && errorResponse.error && errorResponse.error.length > 0) {
					alert(errorResponse.status + " - " + errorResponse.error)

					// Reset flags
					this.paymentFormObj.authorized = false;
					this.paymentFormObj.reinitializeWidget();
					this.paymentFormObj.resetDisplayCardSvg();
					this.payToken = "";
					this._resetCaptcha();

					document.getElementById('processing_pay').style.display = "none";

					const widget = document.getElementById('edliopay');
					widget.style.display = "block";

				} else {
					this._handleGeneralError();
				}
			}
		};

		request.onerror = () => {
			this._handleGeneralError();
		};

		request.send(userResponse.asString);
	}

	_validateSelections (response, node, element, selections, selected) {
		if (selected) {
			this._unmark(node);
			response.addGroup(element, selections);
			return;

		} else if (element.required) {
			this._markForRevision(node);
			response.needsRevision = true;
			response.addGroup(element, []);
			return;

		} else {
			this._unmark(node);
			response.addGroup(element, []);
			return;
		}
	}

	_resetCaptcha() {
		if (window.grecaptcha == null) {
			return
		}

		if (this.isRecaptchaEnabled && window.edlio.isFormsCaptchaActive && (!this.collectPayment || (this.collectPayment && window.edlio.isPayFormsCaptchaActive))) {
			window.grecaptcha.reset();
		}
	}

	_handleGeneralError () {
		alert('An error occurred processing your request. Please refresh the page and try again.');

		const edliopayElement = document.getElementById("edliopay");

		if (edliopayElement == null) {
			this._resetCaptcha();
			this.enableSubmit();

			return;
		}

		edliopayElement.classList.add("finally-hidden");
		document.getElementById("processing_pay").classList.add("finally-hidden");
		document.getElementById("pay_card_info").classList.add("finally-hidden");
		document.getElementById("submit_button").classList.add("finally-hidden");
		document.getElementById("pay_general_error").classList.remove("hidden-init");
	}

	_parseErrorResponse(response) {
		try {
			return JSON.parse(response)
		} catch (e) {
			return null
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/public/classes/form.js